import { Record } from 'immutable';

const PropertyConfigLookupRecord = Record({
  chain: null,
  brand: null,
  propertyId: null
});

export class PropertyConfigLookup extends PropertyConfigLookupRecord {
  chain: string;
  brand: string;
  propertyId: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/property-config-lookup.ts